import { ActivityListTypeEnum } from 'src/models/genericActivityList';
import { MessageListItem } from 'src/models/messageList';

import { Callback } from 'src/util/query/models/Callback';
import { ResultRunTypeBaseRecord } from 'src/util/query/models/ResultRecordBaseType';

import { MessageListCallbackStoreContract } from '../interfaces';

export class GetTheAllMessageModuleMessagesForTheUserCallBack extends Callback<MessageListItem[]> {
	public constructor(
		private readonly store: MessageListCallbackStoreContract,
		private readonly page: number,
		private readonly queryIdentifier: string
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
		this.store.setListLoadError();
	};

	successCallbackFunction = (
		successResponse: MessageListItem[],
		baseRecordSuccessResponse?: ResultRunTypeBaseRecord
	): void => {
		if (!this.store.isLatestQueryIdentifier(ActivityListTypeEnum.ALL, this.queryIdentifier)) {
			return;
		}

		this.store.setAllMessageList({
			page: this.page,
			payload: successResponse,
			totalCount: Number(baseRecordSuccessResponse?.totalCount ?? 0),
		});
	};
}
